module.exports = __webpack_public_path__ + "static/media/thumbnail.d88b988d.jpg";